import AlertListItem from './AlertListItem'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class AlertList extends Component {
  static defaultProps = {
    onCloseClick: () => {}
  }

  static propTypes = {
    alerts: PropTypes.array.isRequired,
    onCloseClick: PropTypes.func
  }

  renderAlert(alert, index) {
    const { onCloseClick } = this.props
    return (
      <AlertListItem key={index} alert={alert} onCloseClick={onCloseClick} />
    )
  }

  render() {
    const { alerts } = this.props
    return <div>{alerts.map(this.renderAlert, this)}</div>
  }
}



// WEBPACK FOOTER //
// ../src/components/AlertList.js